// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDevicesGroups as listGroupsAPI,
    getDevicesGroup as getGroupAPI,
    addDevicesGroup as addGroupAPI,
    updateDevicesGroup as updateGroupAPI,
    deleteDevicesGroup as deleteGroupAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { devicesGroupsApiResponseError, devicesGroupsApiResponseSuccess } from './actions';
import { DevicesGroupsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get group
 * @param {*} payload - group id
 */
function* getGroup({ payload: { id } }) {
    try {
        const response = yield call(getGroupAPI, id );
        const groupItem = response.data.data;
        yield put(devicesGroupsApiResponseSuccess(DevicesGroupsActionTypes.GET_GROUP, groupItem));
    } catch (error) {
        yield put(devicesGroupsApiResponseError(DevicesGroupsActionTypes.GET_GROUP, error));
    }
}

function* addGroup({payload:group}){
    try{
        const response = yield call(addGroupAPI,{...group})
        const groupItem = response.data.data
        yield put(devicesGroupsApiResponseSuccess(DevicesGroupsActionTypes.ADD_GROUP,groupItem))
    } catch(error){
        yield put(devicesGroupsApiResponseError(DevicesGroupsActionTypes.ADD_GROUP,error))
    }
}

function* updateGroup({payload:group}){
    try{
        const response = yield call(updateGroupAPI,{...group})
        const groupItem = response.data.data
        yield put(devicesGroupsApiResponseSuccess(DevicesGroupsActionTypes.UPDATE_GROUP,groupItem))
    }catch(error){
        yield put(devicesGroupsApiResponseError(DevicesGroupsActionTypes.UPDATE_GROUP,error))
    }
}
function* deleteGroup({payload:group}){
    try{
        const response = yield call(deleteGroupAPI,{...group})
        const groupItem = response.data.id
        yield put(devicesGroupsApiResponseSuccess(DevicesGroupsActionTypes.DELETE_GROUP,groupItem))
    }catch(error){
        yield put(devicesGroupsApiResponseError(DevicesGroupsActionTypes.DELETE_GROUP,error))
    }
}

function* listGroups({payload:params}) {
    try {
        const response = yield call(listGroupsAPI, { ...params });
        const listaGroups = response.data.data;
        yield put(devicesGroupsApiResponseSuccess(DevicesGroupsActionTypes.LIST_GROUPS, listaGroups));
    } catch (error) {
        yield put(devicesGroupsApiResponseError(DevicesGroupsActionTypes.LIST_GROUPS, error));
    }
}


export function* watchGetGroup(): any {
    yield takeEvery(DevicesGroupsActionTypes.GET_GROUP, getGroup);
}
export function* watchListGroups(): any {
    yield takeEvery(DevicesGroupsActionTypes.LIST_GROUPS, listGroups);
}
export function* watchAddGroup(): any {
    yield takeEvery(DevicesGroupsActionTypes.ADD_GROUP, addGroup);
}
export function* watchUpdateGroup(): any {
    yield takeEvery(DevicesGroupsActionTypes.UPDATE_GROUP, updateGroup);
}
export function* watchDeleteGroup(): any {
    yield takeEvery(DevicesGroupsActionTypes.DELETE_GROUP, deleteGroup);
}


function* devicesGroupsSaga(): any {
    yield all([
        fork(watchGetGroup),
        fork(watchListGroups),
        fork(watchAddGroup),
        fork(watchUpdateGroup),
        fork(watchDeleteGroup),
    ]);
}

export default devicesGroupsSaga;
